import {
    chakra, Box
} from '@chakra-ui/react';

export const ErrorContainer = chakra(Box, {
    label: 'ErrorContainer',
    baseStyle: {
        m: '24px auto',
        w: '640px',
        h: '90px',

        backgroundColor: 'portal.white01',
        borderWidth: '1px',
        borderColor: 'portal.grey09',
        boxSizing: 'border-box',
        borderRadius: '0px 12px 12px 0px',
        display: 'flex',
        p: '20px 73px 20px 20px',
        borderLeftWidth: '4px',
        borderLeftColor: 'portal.red02'
    }
});

export const ErrorLogo = chakra('img', {
    label: 'ErrorLogo',
    baseStyle: {
        w: '15px',
        h: '15px',
        position: 'relative',
        top: '6px'
    }
});

export const ErrorText = chakra(Box, {
    label: 'ErrorText',
    baseStyle: {
        marginLeft: '10px',
        fontSize: '14px',
        fontFamily: 'Poppins',
        lineHeight: '28px',
        letterSpacing: '-0.2px'
    }
});

export const ContactUsLink = chakra('a', {
    label: 'ContactUsLink',
    baseStyle: {
        fontWeight: '700',
        mr: '5px',
        textTransform: 'lowercase',
        textDecoration: 'underline'
    }
});
